(function () {
  'use strict';

  /* @ngdoc object
   * @name paxMessage
   * @description
   *
   */
  angular
    .module('paxMessage', [
      'ui.router'
    ]);
}());